export enum ScontoRateTypeEnum {
  ABSOLUTE = 'absolute',
  PERCENT = 'percent',
}
